module.exports = __webpack_public_path__ + "img/Frame1.f10bab60.svg";